var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.dataset,"pagination-options":{enabled: true},"theme":"polar-bear"},on:{"on-cell-click":_vm.onCellClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }